import { ERouting } from '@core/type';
import { ArticleContent, PreciousMetalArticlesBySlugEntity } from '@core/type/api';

import { makeServerProps } from '../../../../helpers/make-server-props/make-server-props';
import { useSSRPage } from '../../../../hooks';
import { PagePreciousMetalGuideProps, ViewPreciousMetalGuide } from '../../../../view';

const PagePreciousMetalGuideLevel2 = (props: PagePreciousMetalGuideProps) =>
  useSSRPage<
    PreciousMetalArticlesBySlugEntity & {
      mainPreciousMetalArticle: ArticleContent;
      preciousMetalArticles: ArticleContent[];
    },
    unknown,
    unknown
  >({
    ...props,
    ViewPage: ViewPreciousMetalGuide,
  });

const getServerSideProps = makeServerProps({
  keyRoute: ERouting.PRECIOUS_METAL_GUIDE_LEVEL2,
});

export { getServerSideProps };

export default PagePreciousMetalGuideLevel2;
